class Verify {
	constructor() {
		
	}
	
	// 判断数据类型
	dataType(data = null, type = '') {
		let _type = Object.prototype.toString.apply(data).slice(8, -1).toLowerCase();
		return type ? (type.indexOf(_type) > -1) : _type;
	}
	
	// 验证电子邮箱是否正确
	isEmail(email = '') {
		return /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(email);
	}
	
	// 验证手机号码是否正确
	isMobile(mobile = '') {
		return /^((\+?86)|(\(\+86\)))?[1][3,4,5,7,8][0-9]{9}$/.test(mobile);
	}
	
	// 验证是否数字
	isNumber(number = '') {
		return (['string', 'number'].indexOf(typeof number) > -1) && (number !== '') && (isNaN(number) === false);
	}
	
	// 验证是否网址
	isWebsite(website = '') {
		return /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/.test(website);
	}
	
	// 验证是否中国居民身份证
	isIdentity(identity = '') {
		if (!identity || typeof identity !== 'string') {
			return false;
		}
		const area = {
			11: "北京", 12: "天津",   13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 
			22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 
			35: "福建", 36: "江西",   37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 
			44: "广东", 45: "广西",   46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 
			53: "云南", 54: "西藏",   61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 
			65: "新疆", 71: "台湾",   81: "香港", 82: "澳门", 91: "国外" ,
		};
		let idcard = identity;
		let Y, S, M, JYM, ereg;
		let idcard_array = new Array();
		idcard_array = idcard.split('');
		if (area[parseInt(idcard.substr(0, 2))] == null) {
			return false;
		}
		switch (idcard.length) {
			case 15:
				if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0 || ((parseInt(idcard.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0)) {
					ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/; //测试出生日期的合法性
				} else {
					ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/; //测试出生日期的合法性
				}
				return ereg.test(idcard);
				break;
			case 18:
				if (parseInt(idcard.substr(6, 4)) % 4 == 0 || (parseInt(idcard.substr(6, 4)) % 100 == 0 && parseInt(idcard.substr(6, 4)) % 4 == 0)) {
					ereg = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/; //闰年出生日期的合法性正则表达式
				} else {
					ereg = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/; //平年出生日期的合法性正则表达式
				}
				if (ereg.test(idcard)) {
					S = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 + parseInt(idcard_array[7]) * 1 + parseInt(idcard_array[8]) * 6 + parseInt(idcard_array[9]) * 3;
					Y = S % 11;
					M = 'F';
					JYM = '10X98765432';
					M = JYM.substr(Y, 1);
					return M == idcard_array[17];
				}
				return false;
				break;
			default:
				return false;
				break;
		};
	}
    
    /**** 以下几个验证方法是专属本项目 ****/
    
    verifyName(name = '') {
    	if (name && name.replace(/\s/g, '')) {
    		return true;
    	}
    	return 'Please enter name';
    }
    verifyEmail(email = '') {
    	if (email) {
    		if (/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(email)) {
    			return true;
    		}
    		return 'Please enter correct email address';
    	}
    	return 'Please enter email';
    }
    verifyMobile(mobile = '') {
    	// // 可有可无(输入才验证)
    	// if (!mobile || mobile === '1' || mobile === '+86') {
    	// 	return true;
    	// }
    	if (mobile && (mobile !== '1') && (mobile !== '+86')) {
    		if (/^((\+?86)|(\(\+86\)))?1\d{10}$/.test(mobile)) {
    			return true;
    		}
    		return 'Please enter correct mobile number';
    	}
    	return 'Please enter mobile number';
    }
    verifyPassword(password = '') {
    	if (password) {
    		if (password.length >= 6) {
    			return true;
    		}
    		return 'Password cannot be less than 6 characters';
    	}
    	return 'Please enter password';
    }
    verifyRepassword(repassword = '', password = '') {
    	if (repassword) {
    		if (repassword === password) {
    			return true;
    		}
    		return 'Passwords do not match';
    	}
    	return 'Please re-enter password';
    }
    verifyCountry(country = '') {
    	if (!country) {
    		return 'Please enter country';
    	}
    	return true;
    }
    verifyProvince(province = '') {
    	if (!province) {
    		return 'Please enter province';
    	}
    	return true;
    }
    verifyCity(city = '') {
    	if (!city) {
    		return 'Please enter city';
    	}
    	return true;
    }
    verifyAddress(address = '') {
    	if (!address) {
    		return 'Please enter address';
    	}
    	return true;
    }
    verifyZipCode(zipCode = '') {
    	if (!zipCode) {
    		return 'Please enter zip code';
    	}
    	return true;
    }
    verifyCode(code = '') {
    	if (!code) {
			code = '00';
    		//return 'Please enter code';
    	}
    	return true;
    }
    verifyQuantity(quantity = '') {
    	if (!quantity || isNaN(quantity) || Number(quantity) < 1) {
    		return 'Please enter a number greater than 0';
    	}
    	return true;
    }
    verifyNotes(notes = '') {
    	// 可有可无
    	return true;
    	if (!notes) {
    		return 'Please enter notes';
    	}
    	return true;
    }
    verifyOrder(order = '') {
    	if (!order) {
    		return 'Please enter order number';
    	}
    	return true;
    }
    verify(data = {}) {
        const strategy = Object.create(null);
    	const success = {};
    	const error = {};
        strategy['name'] = this.verifyName;
        strategy['email'] = this.verifyEmail;
        strategy['mobile'] = this.verifyMobile;
        strategy['password'] = this.verifyPassword;
        strategy['repassword'] = this.verifyRepassword;
        strategy['country'] = this.verifyCountry;
        strategy['province'] = this.verifyProvince;
        strategy['city'] = this.verifyCity;
        strategy['address'] = this.verifyAddress;
        strategy['zipCode'] = this.verifyZipCode;
        strategy['code'] = this.verifyCode;
        strategy['quantity'] = this.verifyQuantity;
        strategy['notes'] = this.verifyNotes;
        strategy['order'] = this.verifyOrder;
    	Object.keys(data).forEach(key => {
    		if (strategy[key]) {
    			let result = key === 'repassword' ? strategy[key](data[key], data['password']) : strategy[key](data[key]);
    			if (typeof result === 'string') {
    				error[key] = result;
    			} else {
    				success[key] = true;
    			}
    		} else {
    			error[key] = '';
    		}
    	});
    	let tip = '';
    	if (Object.keys(error).length) {
    		if (Object.keys(error).length === 1 && error.repassword) {
    			tip = error.repassword;
    		} else {
    			tip = 'Please enter' + Object.keys(error).map(key => error[key].replace('Please enter', '')).join(',');
    		}
    	}
    	return {
    		success,
    		error,
    		tip
    	};
    }
}

export default new Verify